function syncNativeMoney() {
  $$('[data-money-pence]').forEach(node => {
    node.innerHTML = productPriceMarkup({price: Number(node.dataset.moneyPence) / 100, comparePrice: Number(node.dataset.compareMoneyPence) / 100}, 1, priceDisplayMode, node.dataset.showSaving === 'true');
  });
}
document.addEventListener('prices:changed', () => { syncNativeMoney(); renderNativeDrawer(); });
syncNativeMoney();
// Show the product name when a visitor arrives from an enquiry-only product.
const enquiryProduct = new URLSearchParams(window.location.search).get('product');
if (enquiryProduct && $('#contact-product') && !$('#contact-product').value) $('#contact-product').value = enquiryProduct.slice(0,200);
